import { ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE } from 'fhir/constants'

export const PATIENT_STATE_GROUP_IDENTIFIER_SYSTEM = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/patient-state`
